<div class="row col-12 p-0 m-0 main-page-section ">
  <!-- <div class="p-0">
        <app-side-nav [item]="meetingNav"></app-side-nav>
    </div> -->
  <div class="col-12 p-0 employee-section">
    <!-- <app-header></app-header> -->
    <div class="col-height">
      <div class="">
        <div>
          <div class="breadcrumbs-section">
            <span class="prev-page pr-1 prev" routerLink="/overview">Home</span>
            <span class="separator">&nbsp; > &nbsp;</span>
            <span class="curr-page pl-1 breadcrumbs-section-font current">Employees</span>
          </div>
          <div class="d-flex justify-content-between meetings-layout">
            <div class="meetings ">Employees
              <br><span class="sub-label"> {{unregisteredLength}}/{{members?.list?.length}} unregistered users | You
                have {{vacantSpace}} vacant seats</span>
            </div>
            <div class="pt-3">
              <button class="cancel cancel-button pr-4" (click)="bulkUploadEmployees()">Bulk Upload employees</button>
              <button class="add-button add" (click)="addEmployee()">Add Employee</button>
            </div>
          </div>
        </div>
        <div class="mt-4 ">
          <div class="search-wrapper col-12 row borders  p-0 m-0 mt-3">
            <label for="search">
              <img class="image-pos search-layout  mt-4" src="/assets/images/search.png" alt="search" loading="lazy">
              <input class="search-box search-padding placeholder-text mt-3" type="text" name="search" id="menu-search"
                [(ngModel)]="searchText" placeholder="Type here to search…">
            </label>
          </div>
        </div>
      </div>
      <!-- <div class="col-12 loader-margin" *ngIf="showLoader">
        <div class="loader"></div>
      </div> -->
      <div class="layout-height pt-4 c2 scroll-position">
        <div *ngIf="members?.list?.length>0">
          <div class="meetings-layout pb-4" *ngFor="let member of members?.list | filter:searchText | paginate: { itemsPerPage: 10,
                                        currentPage: page,
                                        totalItems:members?.list.length }">
            <div class="row-color">
              <div class="d-flex justify-content-between pt-3 ">
                <div class="col-1 pl-4 pr-0 pointer-link"
                  *ngIf="member?.profileUrl != null && member?.profileUrl != ''">
                  <img class="person-image" [src]="member.profileUrl" loading="lazy" />
                </div>
                <div class="col-1 pl-4 no-image pointer-link"
                  *ngIf="member?.profileUrl == null || member?.profileUrl == ''">
                  <span>{{generateInitials(member?.userName)}}</span>
                </div>
                <div class="pl-4 pt-2 col-8 pointer-link">
                  <span class="meeting-room-name" (click)="employeeDetails(member)">{{member?.userName}}
                    <br><span class="pr-1 meeting-time">{{member?.department}}</span> <span
                      *ngIf="member?.department!=null" class="pl-1 verticalLine-details"></span>
                    <span class="meeting-time pr-1">{{member?.phoneNumber}}</span>
                    <!-- <span class="pl-1 verticalLine-details"></span> -->
                    <!-- <span class="meeting-time pr-1">{{member?.address}}</span> -->
                  </span>
                </div>
                <div class="d-flex justify-content-end button-margin-top  col-3">
                  <div *ngIf="!member?.isRegistered">
                    <span class="view-details pointer-link" (click)="resendEmail(member)">Resend email</span>
                    <span class="line-separation mt-1 pl-3"></span>
                    <span class="view-details pl-3 pr-5 pointer-link" (click)="openRevoke(member)">Revoke
                      invitation</span>
                    <ng-template #revokeInvitation let-modal class="text-center">
                      <div class="modal-height">
                        <div class="modal-body">
                          <div class="">
                            <div class="text pt-3 pb-3">Are you sure, you want to revoke invitation?</div>
                            <div class="popup-line"></div>
                          </div>
                        </div>
                        <div class="submit col-12 d-flex justify-content-end col-12-padding">
                          <div class="pr-3">
                            <button type="button " class="cancel-button cancel pt-3"
                              (click)="modal.close('Save click');onCancel('priviledge')">
                              <span class="cancel">Cancel</span></button>
                          </div>
                          <button type="button " class="add-button"><span class="add"
                              (click)="revokeAccess()">Revoke</span></button>
                        </div>
                      </div>
                    </ng-template>
                  </div>

                  <!-- <div *ngIf="member?.isRegistered">
                    <div class="d-flex">
                      <span class="pr-4 activation">Activation </span>
                      <label class="switch pl-5">
                        <input type="checkbox" checked value="tableSelected"
                          (change)="toggleActivationSelection($event, member)">
                        <span class="slider round "></span>
                      </label> -->

                  <div *ngIf="member?.isRegistered">
                    <div class="d-flex">
                      <span class="pr-4 activation">Activation </span>
                      <label class="switch pl-5">
                        <input type="checkbox" [checked]="member?.t0200OrgEmployees[0]?.isActive"
                          [value]="member?.t0200OrgEmployees[0]?.isActive"
                          (change)="toggleActivationSelection($event, member)"
                          (ngModelChange)="toggleActivationSelection($event, member)">
                        <span class="slider round "></span>
                      </label>


                      <ng-template #contentActivation let-modal class="text-center">
                        <div class="modal-height">
                          <div class="modal-body">
                            <div class="">
                              <div class="text pt-3 pb-3">Are you sure, you want to {{statusText}}?</div>
                              <div class="popup-line"></div>
                            </div>
                          </div>
                          <div class="submit col-12 d-flex justify-content-end col-12-padding">
                            <div class="pr-3">
                              <button type="button " class="cancel-button cancel pt-3"
                                (click)="modal.close('Save click');onCancel('activation')">
                                <span class="cancel">Cancel</span></button>
                            </div>
                            <button type="button " class="add-button"><span class="add"
                                (click)="changeActivation($event, member);modal.close('Save click')">{{statusText}}</span></button>
                          </div>
                        </div>
                      </ng-template>

                    </div>
                  </div>
                  <div class=" pl-4 " *ngIf="member?.isRegistered">
                    <div class="d-flex">
                      <span class="pr-4 activation">Credit Points</span>
                      <label class="switch pl-5">
                        <!-- <input type="checkbox" [checked]="member?.isCreditPointAccess"
                          [value]="member?.isCreditPointAccess" (change)="togglePriviledgeSelection($event,member)">
                        <span class="slider round "></span> -->
                        <input type="checkbox" [checked]="member?.isCreditPointAccess"
                          [value]="member?.isCreditPointAccess" (change)="togglePriviledgeSelection($event, member)"
                          (ngModelChange)="togglePriviledgeSelection($event, member)">
                        <span class="slider round "></span>
                      </label>
                      <ng-template #contentCreditPoint let-modal class="text-center">
                        <div class="modal-height">
                          <div class="modal-body">
                            <div class="">
                              <div class="text pt-3 pb-3">Are you sure, you want to {{creditText}} credit point?</div>
                              <div class="popup-line"></div>
                            </div>
                          </div>
                          <div class="submit col-12 d-flex justify-content-end col-12-padding">
                            <div class="pr-3">
                              <button type="button " class="cancel-button cancel pt-3"
                                (click)="modal.close('Save click');onCancel('privilege')">
                                <span class="cancel">Cancel</span></button>
                            </div>
                            <button type="button " class="add-button"><span class="add"
                                (click)="changeCreditStatus( );modal.close('Save click')">{{creditText}}</span></button>
                          </div>
                        </div>
                      </ng-template>
                    </div>

                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>

      </div>
      <div class="d-flex justify-content-center pagination-section" *ngIf="members?.list?.length>=10">
        <div class="row d-flex pagination-border">
          <pagination-controls class="pagination" previousLabel="" (pageChange)="handlePageChange($event)" nextLabel=""
            class="d-flex justify-content-center">
          </pagination-controls>
          <!-- <div class="pr-3 ratio-class pt-1" *ngIf="member?.length>=10">10/{{members?.list?.length}}</div> -->
          <div class="pr-3 ratio-class pt-1">
            {{member?.length}}/{{members?.list?.length}}</div>
          <!-- <div class="pr-3 ratio-class pt-1">10/{{members?.list?.length}}</div> -->
        </div>
      </div>
    </div>

    <!-- <app-footer></app-footer> -->

  </div>
</div>
